import type { date } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { useMemo } from 'react';

export interface RuleContext {
  timezone: date.Timezone;
  dateFormat: string;
  dateTimeFormat: string;
  isoFormat: string;
}

export const useRuleContext = (): RuleContext => {
  const ctxProps = useGlobalStateContextSelectors({
    timezone: prop('user', 'timezone'),
    dateFormat: prop('dateFormat'),
    dateTimeFormat: prop('dateTimeFormat'),
    isoFormat: prop('isoFormat'),
  });

  return useMemo(
    () => ({
      timezone: ctxProps.timezone,
      dateFormat: ctxProps.dateFormat,
      dateTimeFormat: ctxProps.dateTimeFormat,
      isoFormat: ctxProps.isoFormat,
    }),
    [
      ctxProps.timezone,
      ctxProps.dateFormat,
      ctxProps.dateTimeFormat,
      ctxProps.isoFormat,
    ],
  );
};
